export default __webpack_public_path__ + "static/media/edicao.d7f65618.svg";